document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  const updateHeader = () => {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 24);
  };
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  document.querySelectorAll('[data-compare]').forEach((comparison) => {
    const slider = comparison.querySelector('input[type="range"]');
    if (!slider) return;
    const update = () => comparison.style.setProperty('--position', slider.value + '%');
    slider.addEventListener('input', update);
    update();
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('[data-reveal]').forEach((element) => observer.observe(element));

  document.querySelectorAll('[data-journey]').forEach((journey) => {
    const tabs = Array.from(journey.querySelectorAll('[data-journey-tab]'));
    const panels = Array.from(journey.querySelectorAll('[data-journey-panel]'));
    if (!tabs.length || tabs.length !== panels.length) return;
    let activeIndex = journey.dataset.journeyStart === 'last' ? tabs.length - 1 : Number(journey.dataset.journeyStart || 0);
    let playTimer;
    const twoDigits = (number) => String(number + 1).padStart(2, '0');
    const activate = (index, focusTab = false) => {
      activeIndex = (index + tabs.length) % tabs.length;
      tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === activeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
        panels[tabIndex].hidden = !isActive;
      });
      journey.querySelectorAll('[data-journey-current]').forEach((item) => { item.textContent = twoDigits(activeIndex); });
      journey.querySelectorAll('[data-journey-current-year]').forEach((item) => { item.textContent = tabs[activeIndex].dataset.year || ''; });
      journey.querySelectorAll('[data-journey-current-title]').forEach((item) => { item.textContent = tabs[activeIndex].dataset.title || ''; });
      journey.querySelectorAll('[data-journey-current-phase]').forEach((item) => { item.textContent = tabs[activeIndex].dataset.phase || ''; });
      journey.querySelectorAll('[data-journey-prev]').forEach((item) => { item.disabled = activeIndex === 0; });
      journey.querySelectorAll('[data-journey-next]').forEach((item) => { item.disabled = activeIndex === tabs.length - 1; });
      if (focusTab) tabs[activeIndex].focus({ preventScroll: true });
    };
    const stopPlayback = () => {
      if (!playTimer) return;
      window.clearInterval(playTimer);
      playTimer = undefined;
      const playButton = journey.querySelector('[data-journey-play]');
      if (playButton) playButton.textContent = 'Play journey';
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => { stopPlayback(); activate(index); });
      tab.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') { event.preventDefault(); activate(activeIndex + 1, true); }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') { event.preventDefault(); activate(activeIndex - 1, true); }
        if (event.key === 'Home') { event.preventDefault(); activate(0, true); }
        if (event.key === 'End') { event.preventDefault(); activate(tabs.length - 1, true); }
      });
    });
    journey.querySelectorAll('[data-journey-prev]').forEach((button) => button.addEventListener('click', () => { stopPlayback(); activate(activeIndex - 1); }));
    journey.querySelectorAll('[data-journey-next]').forEach((button) => button.addEventListener('click', () => { stopPlayback(); activate(activeIndex + 1); }));
    const playButton = journey.querySelector('[data-journey-play]');
    if (playButton) playButton.addEventListener('click', () => {
      if (playTimer) { stopPlayback(); return; }
      playButton.textContent = 'Pause journey';
      playTimer = window.setInterval(() => {
        if (activeIndex === tabs.length - 1) { stopPlayback(); return; }
        activate(activeIndex + 1);
      }, 2600);
    });
    activate(activeIndex);
  });

  document.querySelectorAll('[data-location-map]').forEach((map) => {
    const pins = Array.from(map.querySelectorAll('[data-map-pin]'));
    const cards = Array.from(map.querySelectorAll('[data-map-card]'));
    pins.forEach((pin, index) => pin.addEventListener('click', () => {
      pins.forEach((item, itemIndex) => {
        const isActive = itemIndex === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-expanded', String(isActive));
        cards[itemIndex].hidden = !isActive;
      });
    }));
  });

  document.querySelectorAll('[data-project-explorer]').forEach((explorer) => {
    const tabs = Array.from(explorer.querySelectorAll('[data-project-tab]'));
    const panels = Array.from(explorer.querySelectorAll('[data-project-panel]'));
    tabs.forEach((tab, index) => tab.addEventListener('click', () => {
      tabs.forEach((item, itemIndex) => {
        const isActive = itemIndex === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', String(isActive));
        panels[itemIndex].hidden = !isActive;
      });
    }));
    explorer.querySelectorAll('[data-project-panel]').forEach((panel) => {
      const mainImage = panel.querySelector('[data-project-main]');
      panel.querySelectorAll('[data-project-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
        mainImage.src = thumb.dataset.image;
        panel.querySelectorAll('[data-project-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
      }));
    });
  });

  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const counter = entry.target;
      const target = Number(counter.dataset.counterTarget || 0);
      if (!Number.isFinite(target)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        counter.textContent = target.toLocaleString();
        counterObserver.unobserve(counter);
        return;
      }
      const duration = 1600;
      const startTime = performance.now();
      const animate = (currentTime) => {
        const progress = Math.min((currentTime - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        counter.textContent = Math.round(target * eased).toLocaleString();
        if (progress < 1) window.requestAnimationFrame(animate);
      };
      window.requestAnimationFrame(animate);
      counterObserver.unobserve(counter);
    });
  }, { threshold: 0.45 });

  document.querySelectorAll('[data-counter]').forEach((counter) => counterObserver.observe(counter));

  document.querySelectorAll('[data-principles-display]').forEach((display) => {
    const tabs = Array.from(display.querySelectorAll('[data-principle-tab]'));
    const panels = Array.from(display.querySelectorAll('[data-principle-panel]'));
    if (!tabs.length || tabs.length !== panels.length) return;
    const activate = (index, focusTab = false) => {
      tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
        panels[tabIndex].hidden = !isActive;
      });
      if (focusTab) tabs[index].focus({ preventScroll: true });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
      if (window.matchMedia('(hover: hover)').matches) tab.addEventListener('pointerenter', () => activate(index));
      tab.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') { event.preventDefault(); activate((index + 1) % tabs.length, true); }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') { event.preventDefault(); activate((index - 1 + tabs.length) % tabs.length, true); }
        if (event.key === 'Home') { event.preventDefault(); activate(0, true); }
        if (event.key === 'End') { event.preventDefault(); activate(tabs.length - 1, true); }
      });
    });
    activate(0);
  });

  document.querySelectorAll('[data-signal-story]').forEach((story) => {
    const tabs = Array.from(story.querySelectorAll('[data-story-tab]'));
    const panels = Array.from(story.querySelectorAll('[data-story-panel]'));
    if (!tabs.length || tabs.length !== panels.length) return;
    let activeIndex = 0;
    const activate = (index, focusTab = false) => {
      activeIndex = (index + tabs.length) % tabs.length;
      tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === activeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
        panels[tabIndex].hidden = !isActive;
      });
      story.querySelectorAll('[data-story-current]').forEach((item) => {
        item.textContent = String(activeIndex + 1).padStart(2, '0');
      });
      if (focusTab) tabs[activeIndex].focus({ preventScroll: true });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
      if (window.matchMedia('(hover: hover)').matches) tab.addEventListener('pointerenter', () => activate(index));
      tab.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') { event.preventDefault(); activate(activeIndex + 1, true); }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') { event.preventDefault(); activate(activeIndex - 1, true); }
        if (event.key === 'Home') { event.preventDefault(); activate(0, true); }
        if (event.key === 'End') { event.preventDefault(); activate(tabs.length - 1, true); }
      });
    });
    activate(0);
  });

  document.querySelectorAll('[data-service-capabilities]').forEach((experience) => {
    const tabs = Array.from(experience.querySelectorAll('[data-service-tab]'));
    const panels = Array.from(experience.querySelectorAll('[data-service-panel]'));
    if (!tabs.length || tabs.length !== panels.length) return;
    let activeIndex = 0;
    const activate = (index, focusTab = false) => {
      activeIndex = (index + tabs.length) % tabs.length;
      tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === activeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
        panels[tabIndex].hidden = !isActive;
      });
      if (focusTab) tabs[activeIndex].focus({ preventScroll: true });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
      if (window.matchMedia('(hover: hover)').matches) tab.addEventListener('pointerenter', () => activate(index));
      tab.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') { event.preventDefault(); activate(activeIndex + 1, true); }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') { event.preventDefault(); activate(activeIndex - 1, true); }
        if (event.key === 'Home') { event.preventDefault(); activate(0, true); }
        if (event.key === 'End') { event.preventDefault(); activate(tabs.length - 1, true); }
      });
    });
    activate(0);
  });

  document.querySelectorAll('.faq-group').forEach((group) => {
    const items = Array.from(group.querySelectorAll('.faq-item'));
    items.forEach((item) => item.addEventListener('toggle', () => {
      if (!item.open) return;
      items.forEach((otherItem) => {
        if (otherItem !== item) otherItem.open = false;
      });
    }));
  });
});
